module.exports = __webpack_public_path__ + "static/media/logo-blue.7eb24c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-blue.png
// module id = ./src/assets/img/logo-blue.png
// module chunks = 11